module.exports = __webpack_public_path__ + "img/product-3.f986b17f.svg";